import { render, staticRenderFns } from "./ProspectNeedFollowUp.vue?vue&type=template&id=498dbedc"
import script from "./ProspectNeedFollowUp.vue?vue&type=script&lang=js"
export * from "./ProspectNeedFollowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports